// src/App.js
import React from "react";
import GlobalStyles from "./components/GlobalStyles";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import International from "./components/International";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import StickyCall from "./components/StickyCall";
import "./index.css";

function App() {
  return (
    <>
      <GlobalStyles />
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <International />
        <Contact />
      </main>
      <Footer />
      <StickyCall />
    </>
  );
}

export default App;
